module.exports = __webpack_public_path__ + "static/img/repast03.ad33a8e9.jpg";